// extracted by mini-css-extract-plugin
export default {"headerContainer":"contact_headerContainer__Ayl91","formContainer":"contact_formContainer__mbO6d","textContainer":"contact_textContainer__WlBTN"};